import { render, staticRenderFns } from "./EntregaAnexosExcluir.vue?vue&type=template&id=ef07ee42"
import script from "./EntregaAnexosExcluir.vue?vue&type=script&lang=js"
export * from "./EntregaAnexosExcluir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports